// extracted by mini-css-extract-plugin
module.exports = {"icon":"src-components-MaterialComponents-MaterialCrossButtonComponent-index-module__icon--ONVl6"};